import { useCallback } from "react";
import { LessonCardViewProps } from "./types";

export const useLessonCardViewHook = ({
  currentCard,
  totalCards,
  currentCardIndex,
  onNextCard,
  onPreviousCard,
  onCompleteCard,
}: LessonCardViewProps) => {
  // Calculate if this is the last card
  const isLastCard = currentCardIndex === totalCards - 1;

  // Handle card completion
  const handleCardComplete = useCallback(
    (score = 0) => {
      onCompleteCard(currentCard?.id || "", score);
    },
    [currentCard?.id, onCompleteCard]
  );

  // Handle next button click
  const handleNext = useCallback(() => {
    onNextCard();
  }, [onNextCard]);

  // Handle previous button click
  const handlePrevious = useCallback(() => {
    onPreviousCard();
  }, [onPreviousCard]);

  // Check if previous button should be disabled
  const isPreviousDisabled = currentCardIndex === 0;

  return {
    isLastCard,
    handleCardComplete,
    handleNext,
    handlePrevious,
    isPreviousDisabled,
  };
};
